module.exports = __webpack_public_path__ + "static/img/quan_2.a58e2196.png";